import React, {useEffect} from "react";
import {useStyles} from "../../../components/styles/ComponentsStyle";
import {Box, Button, FormControlLabel, Switch, Tab, Tabs, TextField, Typography} from "@material-ui/core";
import PropTypes from 'prop-types';
import clsx from "clsx";
import {ReactComponent as TranslationRefreshIcon} from '../../../../../common/images/TranslationRefreshIcon.svg';
import {ReactComponent as TranslationRefreshDisableIcon} from '../../../../../common/images/TranslationRefreshDisableIcon.svg';
import {inject, observer} from "mobx-react";
import {langTypes} from "../../../../../common/enums/ExcelEnum";
import {TranslationLangName} from "../../../../../common/enums/ContentEnum";


function TabPanel(props) {
    const {children, value, index, ...other} = props;


    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function OddStepThree(props) {
    const classes = useStyles();

    const {contentStore,oddStepThreeStore} = props;
    const {stepValue, dayValue} = props.contentStore;

    const onSave = () => {
        oddStepThreeStore.modifyOddStepThreeContent(stepValue, dayValue, () => {
            oddStepThreeStore.getOddStepThreeContent(stepValue, dayValue, processOddStepThreeContent);
            contentStore.setReadyToSaveStep(false);
        });
    }

    const processOddStepThreeContent = (res) => {
        const isCompleted = oddStepThreeStore.isOddStepThreeCompleted(res);
        contentStore.setReadyToMoveExit(isCompleted);
    }

    useEffect(() => {
        oddStepThreeStore.getOddStepThreeContent(stepValue, dayValue, processOddStepThreeContent)
        props.contentStore.setOnSave(onSave);
        return ()=> {
            props.contentStore.setOnSave(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeText = (languageCode, event) => {
        oddStepThreeStore.changeTranslationText(languageCode, event.target.value);
        contentStore.setReadyToSaveStep(oddStepThreeStore.isChangeTranslation());
    }

    const handleChangeEnable = (languageCode) => {
        oddStepThreeStore.changeTranslationEnable(languageCode);
        contentStore.setReadyToSaveStep(oddStepThreeStore.isChangeTranslation());
    }

    const handleRefreshTranslationText = (translation) => {
        const languageCode = translation.languageCode;
        const enText = oddStepThreeStore.mainList.find((tt) => tt.languageCode === 'EN')?.text;

        contentStore.getGeneratedTranslate(languageCode, enText, (text) => oddStepThreeStore.setTranslationText(text, languageCode));
        contentStore.setReadyToSaveStep(oddStepThreeStore.isChangeTranslation());
    }

    return (
        <div className={classes.root}>
            <Box className={clsx(classes.boxWrap, classes.boxWrapTranslation)}>
                <Box>
                    <Box position="static" className={classes.tabBox}>
                        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                            <Tab label="한국어" {...a11yProps(0)} disableRipple/>
                            <Tab label="영어" {...a11yProps(1)} disableRipple/>
                            <Tab label="일본어" {...a11yProps(2)} disableRipple/>
                            <Tab label="중국어" {...a11yProps(3)} disableRipple/>
                        </Tabs>
                    </Box>

                    {oddStepThreeStore.mainList.length > 0 && Array.from({length: 4}, (_, i) => (
                        <TabPanel key={i} value={value} index={i} className={clsx(classes.textBox, classes.textBoxTranslation)}>
                            <ListeningTextBox props={props} tabValue={value}/>
                        </TabPanel>
                    ))}

                </Box>
            </Box>
            <Box className={classes.boxBottomTranslation}>
                {oddStepThreeStore.translationList.length > 0 && oddStepThreeStore.translationList.map((translation, index) => {
                    const languageCode = translation.languageCode;
                    const langName = TranslationLangName[languageCode];
                    const isChangeText = oddStepThreeStore.isChangeTranslationText(languageCode);
                        return (
                            <div key={index}>
                                <Box display={'flex'} justifyContent={'space-between'} className={classes.translationTitle}>
                                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                        <Typography className={classes.langText}>{langName}</Typography>
                                        <Button disableRipple disabled={!isChangeText} onClick={() => handleRefreshTranslationText(translation)}>
                                            {isChangeText ?
                                                <TranslationRefreshIcon/>
                                                :
                                                <TranslationRefreshDisableIcon/>
                                            }
                                        </Button>
                                    </Box>
                                    <Box>
                                        <FormControlLabel
                                            control={<Switch checked={translation.enable} onChange={() => handleChangeEnable(languageCode)} name="checkedB" className={classes.swichStyle}/>}
                                            label="앱 노출"
                                            labelPlacement="start"
                                        />
                                    </Box>
                                </Box>
                                <Box>
                                    <TextField
                                        id="outlined-multiline-static"
                                        multiline
                                        minRows={4}
                                        placeholder="텍스트를 입력해주세요."
                                        variant="outlined"
                                        value={translation.text}
                                        onChange={(event) => handleChangeText(languageCode, event)}
                                    />
                                </Box>
                            </div>
                            )

                    })}
            </Box>
        </div>
    );
};

function ListeningTextBox(parentProps) {
    const {props, tabValue} = parentProps;
    const {oddStepThreeStore} = props;
    const lang = langTypes[tabValue];

    return (
        <>
            <Box>
                <TextField
                    id="outlined-multiline-static"
                    multiline
                    minrows={4}
                    placeholder="텍스트를 입력해주세요."
                    variant="outlined"
                    value={oddStepThreeStore.getMainText(lang)}
                />
            </Box>
        </>
    )
}

export default inject('oddStepThreeStore', 'contentStore')(observer(OddStepThree))
